// src/components/etc/VendorRegister.jsx
import React, { useEffect, useState } from "react";
import api from "../../api";
import VendorForm from "./VendorForm";
import styles from "./VendorRegister.module.css";

export default function VendorRegister({ searchTerm, defaultSalaryAccount = false }) { // ✅ searchTerm prop 추가
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingVendor, setEditingVendor] = useState(null); // ✅ 수정 중인 거래처 상태

  // 거래처 목록 불러오기
  const fetchVendors = async () => {
    try {
      const res = await api.get("/vendors/");
      const data = Array.isArray(res.data)
        ? res.data
        : res.data.results || [];
      setVendors(data);
    } catch (err) {
      console.error("❌ 거래처 목록 불러오기 실패:", err);
      alert("서버에서 거래처 목록을 불러올 수 없습니다.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ 검색어로 필터링 (이 부분 전체를 추가!)
  const filteredVendors = vendors.filter((vendor) => {
    if (!searchTerm) return true; // 검색어가 없으면 전체 표시
    
    const searchLower = searchTerm.toLowerCase();
    return (
      vendor.name?.toLowerCase().includes(searchLower) ||
      vendor.business_number?.includes(searchTerm) ||
      vendor.code?.toLowerCase().includes(searchLower) ||
      vendor.ceo_name?.toLowerCase().includes(searchLower) ||
      vendor.manager?.toLowerCase().includes(searchLower)
    );
  });

  // 새 거래처 추가 또는 수정
  const handleSave = async (vendorData) => {
    try {
      if (editingVendor) {
        // ✅ 수정 모드 (PUT 요청)
        await api.put(`/vendors/${editingVendor.id}/`, vendorData);
        alert("거래처 정보가 수정되었습니다.");
      } else {
        // ✅ 신규 등록 (POST 요청)
        await api.post("/vendors/", vendorData);
        alert("새 거래처가 등록되었습니다.");
      }

      setEditingVendor(null); // 수정모드 해제
      fetchVendors(); // 목록 갱신
    } catch (err) {
      console.error("❌ 거래처 저장 실패:", err);
      alert("저장 중 오류가 발생했습니다.");
    }
  };

  // 수정 버튼 클릭 시 → 해당 거래처를 폼으로 전달
  const handleEditClick = (vendor) => {
    setEditingVendor(vendor);
  };

  // 폼 초기화 요청 시 (수정 취소)
  const handleCancelEdit = () => {
    setEditingVendor(null);
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  if (loading) return <p>로딩 중...</p>;

  return (
    <div className={styles.contentArea}>
      {/* 왼쪽: 등록/수정 폼 */}
      <div className={styles.leftPanel}>
        <VendorForm
          onAdd={handleSave}
          vendors={vendors}
          editingVendor={editingVendor} // ✅ 수정모드일 때 데이터 전달
          onCancelEdit={handleCancelEdit}
          defaultSalaryAccount={defaultSalaryAccount}
        />
      </div>

      {/* 오른쪽: 거래처 목록 */}
      <div className={styles.rightPanel}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Code</th>
              <th>거래처명</th>
              <th>사업자등록번호</th>
              <th>대표자 이름</th>
              <th>담당자 이름(직함)</th>
              <th>설명</th>
              <th>전화번호</th>
              <th>팩스번호</th>
              <th>이메일 주소</th>
              <th>은행명</th>
              <th>계좌번호</th>
              <th>급여계좌</th>
              <th>관리</th> {/* ✅ 수정버튼용 열 */}
            </tr>
          </thead>
          <tbody>
            {filteredVendors.length > 0 ? (
              filteredVendors.map((v) => (
                <tr key={v.id}>
                  <td>{v.code}</td>
                  <td>{v.name}</td>
                  <td>{v.business_number}</td>
                  <td>{v.ceo_name}</td>
                  <td>{v.manager}</td>
                  <td>{v.manager_desc}</td>
                  <td>{v.phone}</td>
                  <td>{v.fax_number}</td>
                  <td>{v.email}</td>
                  <td>{v.bank_name}</td>
                  <td>{v.account_number}</td>
                  <td>{v.is_salary_account ? "O" : ""}</td>
                  <td>
                    <button
                      onClick={() => handleEditClick(v)}
                      className={styles.editButton}
                    >
                      수정
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="13" style={{ textAlign: "center", padding: "20px", color: "#999" }}>
                  {searchTerm 
                    ? `"${searchTerm}"에 대한 검색 결과가 없습니다.`
                    : "등록된 거래처가 없습니다."}
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>
    </div>
  );
}
